/**
 * External dependencies
 */
import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
/**
 * Internal dependencies
 */
import { LoopzGiftCardBlock } from './block';
import metadata from './block.json';
import './style.scss';

if(window.loopzGiftCardData?.redemptionEnabled === 'true') {
	registerCheckoutBlock({
		metadata,
		component: LoopzGiftCardBlock,
	});
}


